import { render, staticRenderFns } from "./OperatoriList.vue?vue&type=template&id=796762aa&scoped=true&"
import script from "./OperatoriList.vue?vue&type=script&lang=js&"
export * from "./OperatoriList.vue?vue&type=script&lang=js&"
import style0 from "./OperatoriList.vue?vue&type=style&index=0&id=796762aa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "796762aa",
  null
  
)

export default component.exports